import React from 'react';
import { showNotification, debounce } from '@common/services';
import {
  Icon,
  NotificationNoAccessErrorMessage,
  NotificationNotFoundErrorMessage,
  NotificationUnexpectedErrorMessage,
} from '@common/components';

type ErrorCodeType = 'non-authorized' | 'not-found' | 'generic';

export function errorHandlerShowErrorNotification(
  errorCode: ErrorCodeType = 'generic'
) {
  const message = {
    'non-authorized': <NotificationNoAccessErrorMessage />,
    'not-found': <NotificationNotFoundErrorMessage />,
    generic: <NotificationUnexpectedErrorMessage />,
  }[errorCode];

  debounce(() => {
    showNotification({
      message,
      icon: <Icon icon="timesCircle" kind="regular" color="coral" size="xl" />,
      duration: 0,
    });
  }, 3000);
}
